import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthResponse } from '../services/api';

type User = AuthResponse['user'];

interface ProtectedRouteProps {
  children: React.ReactNode;
  user: User | null;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, user }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (localStorage.getItem('mustChangePassword')) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;